<template>
	<div class="game-clock">
		{{ formattedTime }}
	</div>
</template>

<script>
import { padStart } from 'lodash-es';

export default {
	name:  'GameClock',
	props: {
		minutes: {
			type:     Number,
			required: true,
		},
		seconds: {
			type:     Number,
			required: true,
		},
	},
	computed: {
		formattedTime() {
			return `${padStart(this.minutes, 2, '0')}:${padStart(this.seconds, 2, '0')}`;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/fonts';

.game-clock {
	@include text-lg-2(true);
	display: inline-flex;
	align-items: center;
	padding: 6px 6px;
	margin-left: 8px;
	background: var(--color-soft-white);
	color: var(--color-shadow-grey);
}
</style>
